import React, { useState } from 'react';

import { Row, Column } from 'components/Layout/Grid';
import { Button } from 'components/Button';
import PasswordValitadorBar from 'components/PasswordValitadorBar';
import Text from 'components/Text';
import Input from 'components/Input';
import Form from 'components/Form';
import queryString from 'query-string';

import UserService from 'services/user.service';

import iconSuccess from 'img/success-img.svg';
import Login from '..';
import { useLocation } from 'react-router-dom';
import { PageViewTracker } from 'components/ApplicationInsights/pageViewTracker';

import './style.scss';

const ResetPassword: React.FC = () => {
  const location = useLocation();
  const [userData, setUserData] = useState({
    password: '',
    repeatPassword: '',
  });

  const _userService = new UserService();

  const [passwordStrength, setPasswordStrength] = useState(0);

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  function onSubmit() {
    setErrorMessage('');

    if (passwordStrength < 5)
      return setErrorMessage('Nova Senha não contém requisitos mínimos');

    setLoading(true);

    const params = queryString.parse(location.search);

    _userService
      .changePassword(params?.token as string, userData.password)
      .then(() => {
        setSuccess(true);
      })
      .catch((err) => {
        setLoading(false);
        return setErrorMessage(
          err.response.data.data || 'Erro ao realizar requisição'
        );
      });
  }

  function goToLoginScreen() {
    window.location.href = '/';
  }

  return (
    <Login>
      <PageViewTracker />
      {!success ? (
        <>
          <Text className="text-wrap color-blue-gray">
            Para configurar uma nova senha de acesso ao Customer Care, preencha
            os campos abaixo:
          </Text>
          <Form id="form_reset_password" onValidate={onSubmit}>
            <Column className="mt-2">
              <Row>
                <Input
                  value={userData.password}
                  className="flex-1 w-100"
                  placeholder="Nova Senha"
                  name="Nova senha"
                  required
                  type="password"
                  onChange={(e: any) =>
                    setUserData({ ...userData, password: e.target.value })
                  }
                />
              </Row>
              <Row className="mt-1">
                <Input
                  value={userData.repeatPassword}
                  type="password"
                  className="flex-1 w-100"
                  placeholder="Confirmar Senha"
                  name="Confirmar senha"
                  required
                  compare={{ name: 'Nova senha', value: userData.password }}
                  onChange={(e: any) =>
                    setUserData({ ...userData, repeatPassword: e.target.value })
                  }
                />
              </Row>
              {errorMessage && (
                <Text className="color-danger mt-2 animated fadeIn" size={14}>
                  {errorMessage}
                </Text>
              )}
              <Row className="mt-3">
                <PasswordValitadorBar
                  password={userData.password}
                  strength={(strength: number) => setPasswordStrength(strength)}
                />
              </Row>
              <Row className="justify-end mt-3">
                <Button
                  form="form_reset_password"
                  isRequesting={loading}
                  disabled={loading}
                  className="bg-primary"
                  width="auto"
                >
                  <Text className="color-white px-3">Redefinir</Text>
                </Button>
              </Row>
            </Column>
          </Form>
        </>
      ) : (
        <Column className="mt-2 align-center">
          <img src={iconSuccess} alt="" className="icon-success-ajust" />
          <Text size={16} className="color-primary font-bold text-center mt-1">
            Senha redefinida com sucesso
          </Text>
          <Text
            size={12}
            className="text-center color-blue-gray mt-3 text-wrap px-10 px-sm-0"
          >
            Seu senha foi redefinida. Clique no botão abaixo para continuar seu
            acesso.
          </Text>
          <Row className="justify-center mt-5">
            <Button
              onClick={goToLoginScreen}
              className="bg-primary outline"
              width="auto"
            >
              <Text className="color-primary px-5">Continuar</Text>
            </Button>
          </Row>
        </Column>
      )}
    </Login>
  );
};

export default ResetPassword;
